import type { FC, SVGProps } from 'react';

const FolderIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.539587 4.37024L0.500031 3.5C0.500031 2.39543 1.39546 1.5 2.50003 1.5H6.1716C6.70204 1.5 7.21074 1.71071 7.58582 2.08579L8.41424 2.91421C8.78932 3.28929 9.29803 3.5 9.82846 3.5H13.81C14.986 3.5 15.9082 4.50984 15.8018 5.68107L15.1654 12.6811C15.0717 13.7112 14.208 14.5 13.1736 14.5H2.82647C1.79206 14.5 0.928332 13.7112 0.834681 12.6811L0.198318 5.68107C0.154263 5.19647 0.286313 4.73949 0.539587 4.37024ZM2.1901 4.5C1.60207 4.5 1.14097 5.00492 1.19421 5.59054L1.83057 12.5905C1.8774 13.1056 2.30926 13.5 2.82647 13.5H13.1736C13.6908 13.5 14.1227 13.1056 14.1695 12.5905L14.8059 5.59054C14.8591 5.00492 14.398 4.5 13.81 4.5H2.1901ZM6.87871 2.79289C6.69117 2.60536 6.43682 2.5 6.1716 2.5H2.50003C1.95405 2.5 1.51027 2.93755 1.50021 3.48112L1.5065 3.61964C1.7193 3.54231 1.94939 3.5 2.1901 3.5H7.58582L6.87871 2.79289Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FolderIcon;
